// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ebFlZ","backButton":"styles_backButton__O4lrh","bodyContainer":"styles_bodyContainer__zqF6r","body":"styles_body__wrvTg"};